var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNadajesidozmywarkiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.2 52.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 60.2,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.7,
    y: 1.47,
    width: 5.91,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.14,
    y: 1.47,
    width: 5.91,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.58,
    y: 1.47,
    width: 5.91,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.49,
    y: 4.46,
    width: 1.42,
    height: 7.12,
    transform: "translate(-2.86 3.48) rotate(-25.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.58,
    y: 24.99,
    width: 1.42,
    height: 7.13,
    transform: "translate(-6.85 13.38) rotate(-17.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.88,
    y: 3.2,
    width: 1.42,
    height: 7.12,
    transform: "translate(-.88 11.91) rotate(-56.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.26,
    y: 7.31,
    width: 7.12,
    height: 1.42,
    transform: "translate(23.82 53.94) rotate(-64.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.42,
    y: 27.76,
    width: 7.12,
    height: 1.42,
    transform: "translate(-.18 56.65) rotate(-64.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 51.1,
    width: 60.2,
    height: 1.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.21,47.97h1.42v-3.49h3.84c2.91,3.45,7.25,5.65,12.12,5.65,3.64,0,6.99-1.24,9.66-3.31,2.99,1.59,6.4,2.5,10.03,2.5,5.14,0,9.86-1.82,13.55-4.84h7.73v3.49h1.42v-4.92h-7.59c3.86-3.86,6.24-9.2,6.24-15.09,0-7.37-3.73-13.86-9.4-17.7l4.77-5.23-1.05-.96-4.8,5.26.84.77c-3.36-2.21-7.39-3.5-11.71-3.5-1.43,0-2.82.14-4.16.41l-.86-2.67-1.36.44.82,2.56c-1.21.33-2.38.75-3.49,1.28l1.43-4.28-1.35-.45-1.9,5.7c-1.71,1.01-3.26,2.26-4.62,3.69l-5.22-3.43-.78,1.19,5.05,3.31c-1.05,1.26-1.95,2.65-2.68,4.14-.18,0-.37-.03-.55-.03-1.81,0-3.54.32-5.16.88l-2.69-5.59-1.28.62,2.65,5.5c-5.51,2.48-9.35,8.01-9.35,14.44,0,3.24.98,6.25,2.65,8.76H.21v4.92ZM12.51,22.76l1.28-.62-.74-1.54c1.43-.47,2.95-.74,4.54-.74,3.98,0,7.58,1.61,10.19,4.22,2.61,2.61,4.22,6.21,4.22,10.19,0,3.3-1.12,6.33-2.99,8.76h-4.67c2.62-2.03,4.32-5.19,4.32-8.76,0-4.19-2.33-7.83-5.76-9.72l.45-1.36-1.35-.45-.4,1.21c-1.25-.49-2.6-.76-4.01-.76-6.12,0-11.08,4.96-11.08,11.08,0,3.57,1.7,6.74,4.32,8.76h-4.67c-1.87-2.43-2.99-5.46-2.99-8.76,0-3.98,1.61-7.58,4.22-10.19,1.24-1.24,2.7-2.24,4.32-2.96l.79,1.64ZM32.15,21.77l.78-1.19-4.34-2.85c1.58-1.35,3.48-2.33,5.57-2.82l2.32,7.21-3.63,3.97,1.05.96,4.8-5.26-1.05-.96-.07.08-2.01-6.26c.56-.07,1.13-.12,1.71-.12,1.84,0,3.59.37,5.18,1.04l-2.71,2.96,1.05.96,2.99-3.27c1.1.61,2.1,1.36,2.98,2.25.52.52.98,1.09,1.41,1.68l-.96,2,1.28.62.58-1.21c1.03,1.9,1.62,4.08,1.62,6.4,0,3.71-1.5,7.07-3.93,9.5-2.43,2.43-5.79,3.93-9.5,3.93-1.8,0-3.51-.36-5.07-1,.79-1.88,1.22-3.94,1.22-6.11,0-5.69-3.01-10.67-7.52-13.46.47-.75,1.01-1.45,1.62-2.09l4.62,3.03ZM13.57,43.05c-1.05-.48-2-1.14-2.8-1.94-1.75-1.75-2.83-4.16-2.83-6.82,0-2.67,1.08-5.08,2.83-6.82,1.18-1.18,2.67-2.05,4.34-2.49l-1.25.6,3.09,6.42,1.28-.62-3.09-6.41c.78-.2,1.6-.32,2.44-.32,1.26,0,2.46.25,3.56.69l-1.4,4.2,1.35.45,1.34-4.01c.72.42,1.38.92,1.97,1.51,1.75,1.75,2.83,4.16,2.83,6.82,0,2.67-1.08,5.08-2.83,6.82-.81.81-1.76,1.46-2.8,1.94h-8.04ZM13.25,44.48c1.33.57,2.8.89,4.34.89,1.54,0,3.01-.32,4.34-.89h5.85,0c-2.61,2.61-6.21,4.23-10.19,4.23-3.98,0-7.58-1.61-10.19-4.22h0s5.85,0,5.85,0ZM37.29,47.9c-3.18,0-6.18-.76-8.84-2.09.45-.42.88-.86,1.27-1.33h18.74c-3.19,2.16-7.03,3.42-11.17,3.42ZM51.38,42.06c-.35.35-.72.67-1.09.99h-19.5c.29-.44.56-.9.81-1.37,1.75.73,3.67,1.13,5.69,1.13,8.21,0,14.86-6.65,14.86-14.86,0-2.92-.85-5.64-2.31-7.93l2.48-5.15c3.05,3.5,4.91,8.07,4.91,13.08,0,5.51-2.23,10.49-5.84,14.1ZM22.04,15.13l1.56,1.02.78-1.19-1.37-.9.18-.2c1.13-1.13,2.4-2.1,3.76-2.93l.46.15.18-.54c1.43-.8,2.97-1.41,4.58-1.84l.91,2.84,1.36-.44-.88-2.73c1.21-.23,2.45-.36,3.72-.36,5.45,0,10.38,2.19,13.98,5.74l-2.38,4.94c-1.14-1.42-2.53-2.63-4.11-3.55l2.33-2.55-1.05-.96-2.59,2.83c-1.88-.87-3.97-1.36-6.18-1.36-3.82,0-7.29,1.45-9.92,3.82l-.38-.25-.78,1.19.13.09c-.62.67-1.17,1.4-1.65,2.18l-.24-.12,2.17-6.5-1.35-.45-2.13,6.4c-1.09-.41-2.24-.7-3.43-.86.66-1.24,1.45-2.4,2.35-3.47Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNadajesidozmywarkiIcon);
export default __webpack_public_path__ + "static/media/Nadaje się do zmywarki_icon.b790d841ff7649d912336a0f1cf99954.svg";
export { ForwardRef as ReactComponent };